import React from 'react';
import { FormattedMessage } from 'react-intl';
import './quote.css';

export const Quote = () => {
    return (
        <div className='quoteContainer'>
            <p className='quote'><FormattedMessage id="Mission.text" /></p>
        </div>);
};


// WEBPACK FOOTER //
// ./src/containers/quote/Quote.js